export const SITE_URL = 'https://delps.net';

export const SUPPORT_NUMBER = '556299875685';

export const RASTREAMENTO_URL = 'https://cliente.delps.net/rastreamento';
